import { render, staticRenderFns } from "./PumpBolusDetailTableRu.vue?vue&type=template&id=528727b7&scoped=true"
import script from "./PumpBolusDetailTableRu.vue?vue&type=script&lang=js"
export * from "./PumpBolusDetailTableRu.vue?vue&type=script&lang=js"
import style0 from "./PumpBolusDetailTableRu.vue?vue&type=style&index=0&id=528727b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528727b7",
  null
  
)

export default component.exports